import { create, test, enforce } from "vest";
import "vest/enforce/compounds";

import {
  EMAIL_REGEXP,
  LATIN_AND_SPECIAL_CHARACTERS_ONLY_REGEXP,
} from "@/constants/regex";

export default create((data = {}) => {
  test("email", () => {
    enforce(data.email)
      .isNotNull()
      .message("Email is required")
      .isNotBlank()
      .message("Please enter a valid email address")
      .condition((value) => EMAIL_REGEXP.test(value));
  });

  test("password", () => {
    enforce(data.password)
      .isNotNull()
      .message("Password is required")
      .isNotBlank()
      .message("Password must be at least 8 characters long")
      .longerThanOrEquals(8)
      .message("Password must be not longer than 72 characters")
      .shorterThanOrEquals(72)
      .message("Password should contain at least one upper case character")
      .condition((value) => /[A-Z]/.test(value))
      .message("Password should contain at least one lower case character")
      .condition((value) => /[a-z]/.test(value))
      .message("Password should contain at least one digit character")
      .condition((value) => /[0-9]/.test(value))
      .message("Password should not contain 3 consecutive identical characters")
      .condition((value) => !/([\S])\1\1/.test(value))
      .message(
        "Password should only contain latin, numeric or special characters"
      )
      .condition((value) =>
        LATIN_AND_SPECIAL_CHARACTERS_ONLY_REGEXP.test(value)
      );
  });

  test("confirmPassword", () => {
    enforce(data.confirmPassword)
      .isNotNull()
      .message("Please confirm your password")
      .isNotBlank()
      .message("Passwords do not match")
      .equals(data.password);
  });

  test("agree", () => {
    enforce(data.agree)
      .isNotNull()
      .message("You need to agree with the terms before signing up")
      .allOf(enforce.isBoolean(), enforce.isTruthy());
  });

  test("recaptchaToken", () => {
    enforce(data.recaptchaToken).isNotNull().isNotBlank();
  });
});
